import { DateTime } from 'luxon'

import { AuxiliarMeta } from '~/layers/forms/models'

export type Pet = Nullable<{
  petType: PropsTypesOf<typeof PetTypeEnum>['code']
  name: string
  microchip: string
  fertility: PropsTypesOf<typeof PetFertilityEnum>['code']
  color: AuxiliarMeta
  breed: AuxiliarMeta
  birthDate: Date
  size: PropsTypesOf<typeof PetSizeEnum>['code']
  gender: PropsTypesOf<typeof PetGenderEnum>['code']
}>

function load(model?: Partial<Pet> | null): Pet {
  return {
    petType: model?.petType ?? 'Dog',
    name: model?.name ?? null,
    microchip: model?.microchip ?? null,
    fertility: model?.fertility ?? null,
    color: model?.color ?? AuxiliarMeta.load(),
    breed: model?.breed ?? AuxiliarMeta.load(),
    birthDate: model?.birthDate ?? null,
    size: model?.size ?? null,
    gender: model?.gender ?? null,
  }
}

export const PetTypeEnum = {
  Cat: { label: 'Gato', code: 'Cat' },
  Dog: { label: 'Perro', code: 'Dog' },
} as const

function getTypeList() {
  return Object.values(PetTypeEnum)
}

export const PetFertilityEnum = {
  Castrated: { label: 'Castrado', code: 'Castrated' },
  Fertile: { label: 'Fértil', code: 'Fertile' },
} as const

function getFertilityTypeList() {
  return Object.values(PetFertilityEnum)
}

export const PetGenderEnum = {
  Male: { label: 'Macho', code: 'Male' },
  Female: { label: 'Hembra', code: 'Female' },
} as const

function getPetGenderTypeList() {
  return Object.values(PetGenderEnum)
}

export const PetSizeEnum = {
  Small: { label: 'Pequeño (hasta 10 Kg)', code: 'Small' },
  Medium: { label: 'Mediano (11 a 25 Kg)', code: 'Medium' },
  Big: { label: 'Grande (26 a 40 Kg)', code: 'Big' },
  Giant: { label: 'Gigante (más de 40 Kg)', code: 'Giant' },
} as const

function getSizeTypeList() {
  return Object.values(PetSizeEnum)
}

const map = {
  toMascotaViewModel(model: Pet): SiteApiSchema<'MascotaViewModel'> {
    return {
      mesNacimiento: model.birthDate
        ? DateTime.fromJSDate(model.birthDate).month.toString()
        : undefined,
      yearNacimiento: model.birthDate
        ? DateTime.fromJSDate(model.birthDate).year.toString()
        : undefined,
      //razaId: model.breed?.id,
      raza: model.breed?.name,
      //colorId: model.color?.id,
      color: model.color?.name,
      esFertil: model.fertility === PetFertilityEnum.Fertile.code ? true : false,
      sexo: model.gender ? PetGenderEnum[model.gender].label : undefined,
      microchip: model.microchip,
      nombre: model.name,
      tipoMascota: model.petType ? PetTypeEnum[model.petType].label : undefined,
      tamano: model.size ? PetSizeEnum[model.size].label : undefined,
    }
  },
}

export const Pet = {
  load,
  getTypeList,
  getFertilityTypeList,
  getSizeTypeList,
  getPetGenderTypeList,
  map,
}
